import axios from '../utils/axios';

export default function getFeedExcludedUsers(adminId, feedType) {
    return axios.get(`/admin/${adminId}/xml-feeds/${feedType}/excluded-users`)
}
